import React, { useContext } from "react"; 
import { TranslatorContext } from "../context/Translator";

export default function PaginationComponent({ totalItems, itemsPerPage, currentPage, onPageChange, loading }) {
    const { t, n, currentLanguage } = useContext(TranslatorContext);
    
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages || loading) return;
        onPageChange(page);
    };

    const renderPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        
        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        if (endPage - startPage < maxVisiblePages - 1) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        if (startPage > 1) {
            pages.push(
                <li 
                    key={1} 
                    className={`mc-paginate-item ${1 === currentPage ? 'active' : ''}`}
                    onClick={() => handlePageChange(1)}
                >
                    {n(1)}
                </li>
            );
            if (startPage > 2) {
                pages.push(<li key="start-ellipsis" className="mc-paginate-item">...</li>);
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <li 
                    key={i} 
                    className={`mc-paginate-item ${i === currentPage ? 'active' : ''}`}
                    onClick={() => handlePageChange(i)}
                >
                    {n(i)}
                </li>
            );
        }

        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                pages.push(<li key="end-ellipsis" className="mc-paginate-item">...</li>);
            }
            pages.push(
                <li 
                    key={totalPages} 
                    className={`mc-paginate-item ${totalPages === currentPage ? 'active' : ''}`}
                    onClick={() => handlePageChange(totalPages)}
                >
                    {n(totalPages)}
                </li>
            );
        }

        return pages;
    };

    return (
        <div className="mc-paginate">
            <p className="mc-paginate-title">
                {t('showing')} 
                <b> {n(startItem)} </b> 
                {t('to')}
                <b> {n(endItem)} </b> 
                {t('of')}
                <b> {n(totalItems)} </b>
                {t('results')}
            </p>
            <ul className="mc-paginate-list">
                <li 
                    className={`mc-paginate-item ${currentPage === 1 || loading ? 'disabled' : ''}`}
                    onClick={() => handlePageChange(currentPage - 1)}
                >
                    { currentLanguage?.dir === "ltr" ? 
                        <i className="material-icons">chevron_left</i> 
                        : <i className="material-icons">chevron_right</i>
                    }
                </li>
                
                {renderPageNumbers()}

                <li 
                    className={`mc-paginate-item ${currentPage === totalPages || loading ? 'disabled' : ''}`}
                    onClick={() => handlePageChange(currentPage + 1)}
                >
                    { currentLanguage?.dir === "ltr" ? 
                        <i className="material-icons">chevron_right</i> 
                        : <i className="material-icons">chevron_left</i>
                    }
                </li>
            </ul>
        </div>
    )
}
